// PATH: src/components/ui/ThemeToggle/ThemeToggle.jsx
import React, { useCallback } from "react";
import { useTheme } from "app/providers/ThemeProvider";
import "./ThemeToggle.css";

function MoonIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path
        d="M21 14.2A8.4 8.4 0 0 1 9.8 3a7.2 7.2 0 1 0 11.2 11.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

function SunIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path
        d="M12 17.2a5.2 5.2 0 1 1 0-10.4 5.2 5.2 0 0 1 0 10.4Zm0-13.9a1 1 0 0 1 1 1V5a1 1 0 1 1-2 0V4.3a1 1 0 0 1 1-1Zm0 16.4a1 1 0 0 1 1 1V21a1 1 0 1 1-2 0v-.3a1 1 0 0 1 1-1ZM4.3 11a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1.3Zm16.4 0a1 1 0 1 1 0 2H21a1 1 0 1 1 0-2h-.3ZM6 6a1 1 0 0 1 1.4 0l.2.2A1 1 0 0 1 6.2 7.6L6 7.4A1 1 0 0 1 6 6Zm10.4 10.4a1 1 0 0 1 1.4 0l.2.2a1 1 0 1 1-1.4 1.4l-.2-.2a1 1 0 0 1 0-1.4ZM18 6a1 1 0 0 1 0 1.4l-.2.2a1 1 0 1 1-1.4-1.4l.2-.2A1 1 0 0 1 18 6ZM7.6 16.4a1 1 0 0 1 0 1.4l-.2.2A1 1 0 0 1 6 18l.2-.2a1 1 0 0 1 1.4 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function ThemeToggle() {
  const theme = useTheme();
  const darkMode = !!theme?.darkMode;

  const handleToggle = useCallback(() => {
    if (typeof theme?.toggleDarkMode === "function") {
      theme.toggleDarkMode();
      return;
    }
    if (typeof theme?.toggleTheme === "function") {
      theme.toggleTheme();
      return;
    }
    if (typeof theme?.dispatch === "function") {
      theme.dispatch({ type: "THEME/TOGGLE_DARK" });
      return;
    }
    if (typeof theme?.setDarkMode === "function") {
      theme.setDarkMode(!darkMode);
    }
  }, [theme, darkMode]);

  const ariaLabel = darkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro";

  return (
    <button
      type="button"
      className={`toggle ${darkMode ? "active" : ""}`}
      onClick={handleToggle}
      role="switch"
      aria-checked={darkMode}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <span className="toggle-handle" aria-hidden="true">
        {/* Icon indicates the next mode (matches your screenshot). */}
        {darkMode ? <SunIcon className="toggle-icon toggle-icon-sun" /> : <MoonIcon className="toggle-icon toggle-icon-moon" />}
      </span>
    </button>
  );
}
